@if (isExitDialogOpen) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="cancelDialog">
        <p class="font-bold z-10">Sure you want to leave?</p>
        <p class="mt-3 z-10">Your changes are not saved automatically and will be discarded if you exit now. Make sure to save your changes before you exit.</p>
        <fa-icon class="mt-3 z-10" [icon]="faTriangleExclamation" size="5x"></fa-icon>
        <div class="h-[38px] mt-5 flex flex-row z-10">
          <full-button [marginRight]="true" (click)="isExitDialogOpen = false" text="Cancel" />
          <outline-button (click)="exitAutoImport()" text="Exit Now" />
        </div>
        <fa-icon class="backgroundExit" [icon]="faTriangleExclamation" size="10x"></fa-icon>
      </div>
    </div>
  </div>
}
@if (openUTCInfo) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-[40%] left-0 right-0 p-5">
        <div class="flex justify-end">
          <button (click)="openUTCInfo = false" class="text-sm rounded-full h-8 w-8 hover:bg-gray-200" aria-label="Close UTC Info">
            <fa-icon [icon]="faXmark" />
          </button>
        </div>
        <p class="font-bold z-10 mb-3 text-center">What is UTC?</p>
        <p>UTC stands for Coordinated Universal Time.</p>
        <br/>
        <p>It is a standard used to establish time zones worldwide. For example, New York City is in the UTC-5 time zone, which means the time in NYC is five hours behind UTC (except during U.S. daylight savings, when it is four hours behind).</p>
      </div>
    </div>
  </div>
}
@if (openAddRoleDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-[30%] left-0 right-0 p-5 text-left">
        <!-- TODO add on selection to load the role's subjects and units -->
        <p class="font-bold z-10 mt-3">Add new role</p>
        <dropdown-search [getRoleDetails]="true" [items]="userRoles" [addedList]="addedTempUserRole" [singleItemList]="true" placeholder="Search for roles" class="mt-2"/>
        @if (addedTempUserRole.length > 0) {
          <div>
            @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0 || addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
              <p class="text-sm mt-2">
                You can optionally add the context of this user's role. For this initial role during user creation you can only have one subject and one unit. By default they will have the role's permission system wide.
              </p>
            }
            @if (addedTempUserRole[0].subjects != null && addedTempUserRole[0].subjects.length !== 0) {
              <div>
                <p class="mt-3 text-sm">Subjects</p>
                <dropdown-search [items]="addedTempUserRole[0].subjects" [addedList]="addedSubjectList" [singleItemList]="true" placeholder="Choose subjects"/>
              </div>
            }
            @if (addedTempUserRole[0].units != null && addedTempUserRole[0].units.length !== 0) {
              <div>
                <p class="mt-3 text-sm">Units</p>
                <dropdown-search [items]="addedTempUserRole[0].units" [addedList]="addedUnitList" [singleItemList]="true" placeholder="Choose units"/>
              </div>
            }
          </div>
        }
        <div class="flex justify-end mt-2">
          <full-button [marginRight]="true" (click)="saveNewRole(addedTempUserRole, addedSubjectList, addedUnitList)" text="Save Role configuration" />
          <clear-button (click)="cancelAddRole()" text="Cancel" />
        </div>
      </div>
    </div>
  </div>
}
@if (testLog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="min-w-[500px] sampleFile">
        <div class="flex flex-col h-full w-full p-5 overflow-y-hidden">
          <div class="flex-none">
            <div class="flex flex-row justify-between pb-1">
              <p class="text-center font-semibold text-xl">Import Log Details</p>
              <clear-button (click)="exitTestDetail()" [faIcon]="faXmark" text="Exit" />
            </div>
            <hr class="-mx-5"/>
            @if (testDetails != null) {
              <div>
                @if (testDetails.allnew !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      New Users Added: {{testDetails.allnew}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Brand new users</p>
                  </div>
                }
                @if (testDetails.justroles !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Existing Users with New Roles: {{testDetails.justroles}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users had this role added to them</p>
                  </div>
                }
                @if (testDetails.nochange !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Users with No Change: {{testDetails.nochange}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users that already exist with this role</p>
                  </div>
                }
                @if (testDetails.nouname !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      No Username Users: {{testDetails.nouname}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users within the .csv that did not have a username provided</p>
                  </div>
                }
                @if (testDetails.noemail !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      No Email Users: {{testDetails.noemail}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users within the .csv that did not have an email provided</p>
                  </div>
                }
                @if (testDetails.errors !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Error Users: {{testDetails.errors}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Unknown error adding these users</p>
                  </div>
                }
                @if (testDetails.badroles !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Incomplete Users: {{testDetails.badroles}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users with incomplete info</p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<save-popup [show]="openSavePopup"/>
<breadcrumb endText="Create Automatic Roster Import" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <div>
    <div class="flex justify-between">
      <h1 class="font-medium text-xl">
        {{rosterId? 'Edit' : 'Create'}} Automatic Roster Import
      </h1>
      <div class="mb-1">
        <full-button (click)="testConnection()" text="Test Connection" [marginRight]="true" />
        <clear-button (click)="openExitDialog('dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImport/Log')" text="View Logs" />
      </div>
    </div>
    <hr />
  </div>
  <div class="lg:w-[80%] text-sm mt-4" [formGroup]="importForm">
    <p>Welcome to the automatic roster import form.</p>
    <p>Here you can create/edit a configuration to import a list of users automatically.</p>
    <p>Required fields are marked with an asterisk <b [style]="primaryColor">(*)</b>.</p>
    <div class="grid grid-cols-3 mt-8">
      <p>
        <b>
          IP Address <span [style]="primaryColor">*</span>
        </b>
      </p>
      <input formControlName="ip" placeholder="example: 192.168.1.0" class="col-span-2 input" [(ngModel)]="ipAddress"/>
      @if (ipValidation) {
        <div class="mt-1"></div>
      }
      @if (ipValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">IP Address is required</p>
      }
      <p class="mt-5">
        <b>
          Transfer Protocol <span [style]="primaryColor">*</span>
        </b>
      </p>
      <select formControlName="protocol" class="input mt-5 col-span-2" [(ngModel)]="protocol">
        <option>FTP</option>
        <option>SFTP</option>
        <option>FTPS</option>
        <option>HTTP</option>
      </select>
      <p class="mt-5">
        <b>
          Port <span [style]="primaryColor">*</span>
        </b>
      </p>
      <input formControlName="port" type="number" placeholder="Enter port number" class="col-span-2 mt-5 input" [(ngModel)]="port"/>
      @if (portValidation) {
        <div class="mt-1"></div>
      }
      @if (portValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">Port is required</p>
      }
      <p class="mt-5">
        <b>
          Relative File Location Path <span [style]="primaryColor">*</span>
        </b>
      </p>
      <input formControlName="fileLocationPath" placeholder="example: /home/user/desktop/roster.csv" class="col-span-2 mt-5 input" [(ngModel)]="fileLocationPath"/>
      @if (fileLocationValidation) {
        <div class="mt-1"></div>
      }
      @if (fileLocationValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">File location path is required</p>
      }
      <p class="mt-5">
        <b>
          Choose Import Frequency <span [style]="primaryColor">*</span>
        </b>
      </p>
      <div class="mt-5">
        <mat-radio-group formControlName="frequency" [(ngModel)]="importFrequency" (change)="selectFreq()" aria-label="Select an option">
          <mat-radio-button value="day">Daily</mat-radio-button>
          <mat-radio-button value="week">Weekly</mat-radio-button>
          <mat-radio-button value="month">Monthly</mat-radio-button>
        </mat-radio-group>
        @if (importFrequencyValidation) {
          <div class="mt-1"></div>
        }
        @if (importFrequencyValidation) {
          <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">Import Frequency is required</p>
        }
      </div>
      <div class="mt-5 flex items-center">
        @if (importFrequency === 'week') {
          <div>
            <select formControlName="weekDay" class="input" [(ngModel)]="weeklyDay">
              <option value="0">Sunday</option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
            </select>
          </div>
        }
        @if (importFrequency === 'month') {
          <div>
            <input formControlName="date" type="date" class="input" id="monthlyPicker" min="{{currentDate | date:'yyyy-MM-dd'}}" [(ngModel)]="monthlyDate"/>
          </div>
        }
      </div>
      @if (monthlyValidation) {
        <div class="mt-1"></div>
      }
      @if (monthlyValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">Date is required</p>
      }
      <p class="mt-5">
        <b>
          Import Time <span [style]="primaryColor">*</span>
        </b>
      </p>
      <div class="col-span-2 flex items-center mt-5">
        <div class="flex-grow mr-1">
          <p><b>Local Time</b></p>
          <input formControlName="time" type="time" class="w-full input" [(ngModel)]="time" (change)="setUTCTime()"/>
        </div>
        <div>
          <p><b>UTC Time</b></p>
          <div class="flex items-center">
            {{utcTime}}
            <button (click)="openUTCInfo = true" class="ml-1 text-xs text-slate-600" aria-label="Open UTC Info">
              <fa-icon [icon]="faCircleInfo" />
            </button>
          </div>
        </div>
      </div>
      @if (timeValidation) {
        <div class="mt-1"></div>
      }
      @if (timeValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">Import time is required</p>
      }
      <p class="mt-5">
        <b>
          Choose Role <span [style]="primaryColor">*</span>
        </b>
      </p>
      <div class="col-span-2 flex justify-between items-center">
        <clear-button [disabled]="addedUserRoleToBeSaved != null" (click)="openAddRoleDialog = true" text="Add Role"  class="mt-4"/>
        @if (addedUserRoleToBeSaved != null) {
          <div>
            <div class="flex flex-shrink lg:flex-grow items-center mt-5 border border-gray-200 rounded-[4px] px-2 py-2 justify-between text-xs h-fit">
              <div>
                Role name = {{addedUserRoleToBeSaved.name}}
                {{addedUserRoleToBeSaved.subjects != null && addedUserRoleToBeSaved.subjects.length > 0? "| Subject name = " + addedUserRoleToBeSaved.subjects[0].name: ""}}
                {{addedUserRoleToBeSaved.units != null && addedUserRoleToBeSaved.units.length > 0? "| Unit name = " + addedUserRoleToBeSaved.units[0].name: ""}}
              </div>
              <button (click)="removeRole()" class="hover:bg-gray-200 rounded-full p-0.5 w-8 h-8 ml-1">
                <fa-icon [icon]="faXmark"/>
              </button>
            </div>
          </div>
        }
      </div>
      @if (roleValidation) {
        <div class="mt-1"></div>
      }
      @if (roleValidation) {
        <p class="mt-1 col-span-2 text-xs text-red-500 font-semibold">Role is required</p>
      }
      <p class="mt-5">
        <b>
          Username
        </b>
      </p>
      <input formControlName="username" placeholder="Enter username" class="col-span-2 mt-5 input" [(ngModel)]="username"/>
      <p class="mt-5">
        <b>
          SSH private key
        </b>
      </p>
      <div class="col-span-2 mt-5" (dragover)="sshOnDrag($event)" (drop)="sshOnDrop($event)" (dragleave)="dragLeave($event)">
        @if (!openDragFileDialog) {
          <textarea
            formControlName="sshKey"
            placeholder="Enter SSH private key or drag and drop file"
            class="w-full h-[100px] p-2 input"
            [(ngModel)]="privkey"
            >
          </textarea>
        }
        @if (openDragFileDialog) {
          <div class="pointer-events-none">
            <div class="border border-gray-500 border-dashed bg-gray-300 rounded-[8px] p-[0.25rem] h-[100px] text-center">
              <fa-icon [icon]="faFileUpload" class="text-3xl text-gray-500" />
              <div class="text-sm mt-3">
                Drop your SSH private key here, should be a .rsa file.
              </div>
            </div>
          </div>
        }
        @if (keySet) {
          <p class="mt-1 w-full">A key exists and is saved</p>
        }
        @if (keySet) {
          <mat-checkbox [ngModel]="keySetChange" (change)="changeKeySet()" color="primary">Replace key?</mat-checkbox>
        }
      </div>
      <p class="mt-5">
        <b>
          Activate config
        </b>
        <fa-icon
          [icon]="faCircleInfo"
          matTooltip="This option allows you to enable/disable the automation without having to delete the entire config."
          class="text-gray-400 cursor-pointer text-xs">
        </fa-icon>
      </p>
      <mat-slide-toggle formControlName="activate" class="mt-5" color="primary" [(ngModel)]="activateConfig"/>
      <div class="col-span-3 flex justify-end mt-10 mb-5">
        <outline-button [marginRight]="true" (click)="_location.back()" text="Cancel" />
        <full-button (click)="saveConfig()" text="Save" />
      </div>
    </div>
  </div>
</div>
